import { action } from 'mobx';
import Collection from 'core/model/Collection';

class SecurityGroupRulesCollection extends Collection {
  @action
  getFilterValues(model) {
    const modelData = model.toJS();
    return [...Object.values(modelData), ...Object.values(model.get('properties'))];
  }
}

export default SecurityGroupRulesCollection;
